<template>
  <section>
    <h3 class="text-h5 mb-2 text-md-h4 mb-md-4">
      Бесплатное мобильное приложение для ваших пациентов
    </h3>
    <h4 class="font-weight-regular mb-6 mb-md-12 text-body-1 text-md-landing-body-1">
      Привлекайте больше пациентов в клинику с помощью МедТочки.
    </h4>

    <v-row>
      <v-col :cols="$display.mdAndUp.value ? 'auto' : 12">
        <v-sheet
          color="ui-kit-bg-secondary"
          class="px-6 pt-8 rounded-xl h-100 d-flex flex-column justify-space-between"
          elevation="0"
          :max-width="$display.mdAndUp.value ? 356 : '100%'"
        >
          <div
            class="mb-4 mb-md-0"
            :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'text-h6'"
          >
            Напомнит пациентам о приёме и повысит посещаемость
          </div>

          <v-img
            aspect-ratio="2.0429447853"
            width="100%"
            class="mt-4 align-self-center"
            src="/images/features/clinic/appointment_push.png"
            srcset="/images/features/clinic/appointment_push.png 1x, /images/features/clinic/appointment_push_3x.png 3x"
            alt="Уведомление о приёме"
            :height="$display.mdAndUp.value ? 163 : 127"
          />
        </v-sheet>
      </v-col>

      <v-col>
        <v-sheet
          color="ui-kit-bg-secondary"
          class="d-flex justify-space-between rounded-xl flex-column flex-md-row"
          elevation="0"
        >
          <div class="px-6 pt-8 mb-4">
            <div :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'text-h6'">
              Вернёт пациентов на
              <br v-if="$display.mdAndUp.value" />
              повторные приёмы
            </div>
            <div
              class="text-ui-kit-text-secondary mt-2 mt-md-4"
              :class="$display.mdAndUp.value ? 'text-landing-body-2' : 'text-body-1'"
            >
              10 руб/запись
            </div>
          </div>
          <v-img
            height="304"
            width="304"
            class="align-self-center"
            src="/images/features/clinic/appointment_repeat.png"
            srcset="/images/features/clinic/appointment_repeat.png 1x,
                      /images/features/clinic/appointment_repeat_3x.png 3x"
            alt="Повторная запись на приём"
          />
        </v-sheet>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="$display.mdAndUp.value ? 7 : 12">
        <v-sheet
          color="ui-kit-bg-secondary"
          class="d-flex justify-space-between rounded-xl flex-column flex-md-row"
          elevation="0"
        >
          <div class="px-6 pt-8 mb-4">
            <div :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'text-h6'">
              Снизит операционные издержки
            </div>
            <div
              class="text-ui-kit-text-secondary mt-2 mt-md-4"
              :class="$display.mdAndUp.value ? 'text-landing-body-2' : 'text-body-1'"
            >
              Пациенты смогут перенести<br /> или отменить запись без администраторов
            </div>
          </div>

          <v-img
            height="304"
            width="302"
            class="align-self-center"
            src="/images/features/clinic/appointment_cancel.png"
            srcset="/images/features/clinic/appointment_cancel.png 1x,
                    /images/features/clinic/appointment_cancel_3x.png 3x"
            alt="Отмененная запись на приём"
          />
        </v-sheet>
      </v-col>

      <v-col :cols="$display.mdAndUp.value ? 5 : 12">
        <v-sheet
          color="ui-kit-bg-secondary"
          class="d-flex flex-column justify-space-between rounded-xl pt-8"
          elevation="0"
          :height="$display.mdAndUp.value ? 304 : undefined"
        >
          <div
            class="px-6 mb-4"
            :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'text-h6'"
          >
            Соберёт обратную связь о вашей клинике и врачах
          </div>

          <v-img
            class="align-self-center"
            alt="Уведомление и форма обратной связи о приёме"
            :width="$display.mdAndUp.value ? 458 : 304"
            :aspect-ratio="$display.mdAndUp.value ? 2.3608247423 : 2.4"
            :src="`/images/features/clinic/appointment_feedback${$display.mdAndUp.value ? '' : '_mobile'}.png`"
            :srcset="$display.mdAndUp.value ? undefined :
              '/images/features/clinic/appointment_feedback_mobile.png 1x,' +
              '/images/features/clinic/appointment_feedback_mobile_3x.png 3x'"
          />
        </v-sheet>
      </v-col>
    </v-row>

    <v-sheet
      class="ad-block d-flex rounded-lg mt-6 align-center flex-column px-6 py-6
      flex-md-row py-md-0 justify-md-space-between py-md-2"
    >
      <div class="d-flex align-center mb-8 mb-md-0">
        <v-img
          class="d-none d-md-block"
          src="/graphics/finger-up.svg"
          width="120"
          height="120"
        />
        <div class="text-h6 text-md-landing-h5 ml-md-6">
          Хотите узнать больше?<br />
          Оставьте контактные данные — мы вам перезвоним
        </div>
      </div>

      <LandingFeatureBtn
        color="ui-kit-bg-primary"
        class="text-primary primary"
        breakpoint="md"
        width="205"
        @click="$emit('click')"
      >
        Как подключить
      </LandingFeatureBtn>
    </v-sheet>
  </section>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

defineEmits(['click'])

const $display = useDisplay()
</script>

<style lang="scss">
.ad-block {
  border: 2px solid $t-ui-bg-primary !important;
}
</style>
